/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Calendar from "./Calendar";
import CalendarContext from "./CalendarContext";
import AppContext from "AppContext";
import { hasElements } from "utils/arrays";
import { notifyError } from "redux/actions/Notifications";
import Filters from "./components/Filters";

export default function CalendarIndex() {
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();
    const [resources, setResources] = useState({ users: [] });
    const [filters, setFilters] = useState({ module: "all" });

    const {
        api: {
            Settings: { Users },
        },
    } = useContext(AppContext);

    const getUsers = () => {
        Users.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    users: data,
                }));
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    users: [],
                }));
                dispatch(notifyError(error));
            },
        });
    };

    useEffect(() => {
        getUsers();

        return () => {
            setResources((prev) => ({ ...prev, users: [] }));
        };
    }, []);

    const getEventCalendarName = (event, mode) =>
        hasElements(resources.users) && resources.users.find((x) => x.id === event.ownerUserId).name;

    return (
        <CalendarContext.Provider value={{ filters, setFilters, user, resources, getEventCalendarName, FiltersComponent: Filters }}>
            <Calendar />
        </CalendarContext.Provider>
    );
}
